<template>
  <div class="d-flex">
    <span v-if="isFriend(user.id)" class="ml-auto">
      <v-btn
        small
        color="green white--text"
        class="mr-3"
        x-small
        :to="'/messages?user=' + user.id"
        >Message</v-btn
      >
      <v-btn small color="primary" x-small @click="lc_disconnect">Disconnect</v-btn>
    </span>
    <span
      v-else-if="isRequestSent(user.id)"
      @click="lc_cancel_request"
      class="ml-auto"
    >
      <v-btn small x-small color="primary">Cancel Request</v-btn>
    </span>
    <span v-else-if="isRequestRecived(user.id)" class="ml-auto">
      <v-btn small color="primary" x-small @click="lc_accept_request">Accept</v-btn>
      <v-btn
        small
        color="red white--text"
        class="ml-3"
        x-small
        @click="lc_reject_request"
        >Reject</v-btn
      >
    </span>
    <span v-else class="ml-auto" @click="lc_connect">
      <v-btn small color="primary" x-small>Connect</v-btn>
    </span>
  </div>
</template>

<script>
export default {
  props: ["user"],
  methods: {
    async lc_cancel_request() {
      let obj = {
        requested_by: this.authUser.id,
        requested_to: this.user.id,
      };
      await this.cancelRequest(obj);
    },
    async lc_accept_request() {
      let obj = {
        requested_by: this.user.id,
        requested_to: this.authUser.id,
      };
      await this.acceptRequest(obj);
    },
    async lc_reject_request() {
      let obj = {
        requested_by: this.user.id,
        requested_to: this.authUser.id,
      };
      await this.rejectRequest(obj);
    },
    async lc_connect() {
      let obj = {
        requested_by: this.authUser.id,
        requested_to: this.user.id,
      };
      await this.sendConnectRequest(obj);
    },
    async lc_disconnect() {
      let obj = {
        user1: this.authUser.id,
        user2: this.user.id,
      };
      await this.disconnect(obj);
    },
    isRequestSent(id) {
      let isSent = this.requestedBy.find((user) => user.requested_to == id)
        ? true
        : false;
      return isSent;
    },
    isRequestRecived(id) {
      let isRecieve = this.requestedTo.find((user) => user.requested_by == id)
        ? true
        : false;
      return isRecieve;
    },
    isFriend(id) {
      
      let userConnects = this.authUser.connects ? this.authUser.connects : [];
      let hasConnect = userConnects.find((connect) => connect == id)
        ? true
        : false;
      return hasConnect;
    },
  },
};
</script>

<style>
</style>